import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Form,
  Input,
  message,
  Modal,
  InputNumber,
  Space,
  Table,
  Tag,
  Card,
  Row,
  Col,
  Image,
  Switch,
  List,
  Upload,
  Divider,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { AiFillDelete } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import debounce from "lodash.debounce";
import UploadFile from "../../components/UploadFile";
import adsApi from "../../api/adsApi";
import { fileManagerActions } from "../../store";
import { LocalImage } from "../../components/ImageUtil";
import TextArea from "antd/lib/input/TextArea";
import Swal from "sweetalert2";

const dataExample = {
  name: null,
  order: null,
  background: null,
  status: false,
  link: null,
  image: null,
  description: null,
};
const AdsProducts = (props) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [valueForm, setValueForm] = useState(dataExample);
  const [isEditModal, setIsEditModal] = useState(false);
  const [btnDeleted, setBtnDeleted] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [listDeleted, setListDeleted] = useState([]);

  const [lstAds, setLstAds] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [inputFilter, setFilter] = useState({
    name: null,
    sortBy: "createdAt:desc",
    page: 1,
    limit: 10,
  });

  const { fileImageUrl } = useSelector((x) => x.fileManager);

  useEffect(() => {
    getAds();
    form.setFieldsValue(valueForm);
  }, [inputFilter, form, valueForm]);

  const handleSearch = (e) => {
    setFilter({ ...inputFilter, name: e.target.value });
  };

  const getAdsDebounce = useMemo(() => debounce(handleSearch, 300), []);

  const getAds = () => {
    adsApi.getAllAds(inputFilter).then((res) => {
      if (res?.results) {
        setLstAds(res?.results);
        setTotalCount(res?.totalResults);
      }
      setLoading(false);
    });
  };

  const setImageNull = (url) => {
    dispatch(fileManagerActions.setUrlImageUp(url));
  };

  const columns = [
    {
      title: "STT",
      render: (text, record, index) => (page - 1) * pageSize + index + 1,
      className: "text-center",
      width: "5%",
    },
    {
      title: "Ảnh hiển thị",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <>
          <LocalImage
            src={image}
            width={100}
            style={{ objectFit: "contain" }}
            height={100}
          />
        </>
      ),
      width: 150,
      className: "text-center",
    },
    {
      title: "Tên chương trình",
      dataIndex: "name",
    },
    {
      title: "Liên kết",
      dataIndex: "link",
      render: (text) => (
        <a target={"_blank"} href={text}>
          {text}
        </a>
      ),
    },
    {
      title: "Mô tả",
      dataIndex: "description",
      render: (text) => <span>{text}</span>,
      className: "whiteSpace-nowrap",
      width: 250,
    },
    {
      title: "Thứ tự hiển thị",
      dataIndex: "order",
      render: (text) => <h6>{text}</h6>,
      width: 10,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: (active) => (
        <>
          {active === true && (
            <Tag color="green" key={active}>
              Hoạt động
            </Tag>
          )}
          {active === false && (
            <Tag color="red" key={active}>
              Không hoạt động
            </Tag>
          )}
        </>
      ),
    },
    {
      title: "Hành động",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => showEditModal(record)}
            value="large"
            icon={<EditOutlined />}
          >
            Sửa
          </Button>
          <Button
            value="large"
            type="primary"
            icon={<DeleteOutlined />}
            danger
            onClick={() => deleteAds(record)}
          >
            Xóa
          </Button>
        </Space>
      ),
      width: 150,
      className: "text-center",
       fixed: "right",
    },
  ];

  function onChange(pagination, filters, sorter, extra) {
    setPageSize(pagination.pageSize);
    if (pagination && pagination.current) {
      setPage(pagination.current);
    }
    let sort = "createdAt:desc";
    if (sorter && sorter.columnKey) {
      let order = "ASC";
      if (sorter.order === "descend") {
        order = "DESC";
      }
      sort = sorter.columnKey + " " + order;
    }
    setFilter({
      name: inputFilter.name,
      sortBy: sort,
      limit: pagination.pageSize,
      page: pagination.current,
    });
  }

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (newSelectedRowKeys.length > 0) {
      setListDeleted(`${newSelectedRowKeys}`);
      setBtnDeleted(true);
    } else {
      setListDeleted([]);
      setBtnDeleted(false);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onFinish = useCallback(
    (values) => {
      if (isEditModal) {
        updateAds(values);
      } else {
        if (fileImageUrl !== null) {
          createAds(values);
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: "Vui lòng tải ảnh lên!",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
      }
    },
    [isEditModal, fileImageUrl]
  );

  const createAds = (data) => {
    const payload = {
      name: data.name,
      link: data.link,
      order: data.order,
      image: fileImageUrl,
      description: data.description,
      status: data.status,
    };
    console.log(payload);
    adsApi.createAds(payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Tạo thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getAds();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const updateAds = (data) => {
    const payload = {
      name: data.name,
      link: data.link,
      order: data.order,
      image: fileImageUrl,
      description: data.description,
      status: data.status,
    };
    console.log(payload);
    adsApi.updateAds(data.id, payload).then(
      (res) => {
        if (!res.code) {
          Swal.fire({
            title: "Thành Công!",
            text: "Sửa thành công!",
            icon: "success",
            confirmButtonText: "OK",
          });
          setIsModalEditVisible(false);
          getAds();
        } else {
          Swal.fire({
            title: "Thất bại!",
            text: res.message,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
      (err) => {
        // console.log("err", err);
        Swal.fire({
          title: "Thất bại!",
          text: err.response?.data?.message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    );
  };

  const confirm = Modal.confirm;

  const deleteAds = (record) => {
    const data = {
      ids: [record.id],
    };
    confirm({
      title: "Bạn có muốn xóa chương trình này không?",
      onOk() {
        adsApi
          .deleteAds(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getAds();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const deleteAllAds = () => {
    const data = {
      ids: listDeleted,
    };
    confirm({
      title: "Bạn có muốn xóa các chương trình này không?",
      onOk() {
        adsApi
          .deleteAds(data)
          .then((res) => {
            if (res) {
              message.success("Bạn đã xóa thành công");
              getAds();
            } else {
              message.error("Xóa thất bại");
            }
          })
          .catch(() => {
            message.error("Xóa thất bại");
          });
      },
      onCancel() {},
    });
  };

  const closePopup = useCallback(() => {
    setValueForm(dataExample);
    form.resetFields();
    setIsModalEditVisible(false);
  }, [form]);

  const showEditModal = (record) => {
    setIsEditModal(true);
    setTitleModal("Sửa chương trình");
    setImageNull(record.image || null);
    setValueForm({
      id: record.id,
      name: record.name,
      link: record.link,
      order: record.order,
      description : record.description,
      status  : record.status,
    });
    setIsModalEditVisible(true);
  };
  const showCreateModal = () => {
    setIsEditModal(false);
    setTitleModal("Thêm chương trình");
    setValueForm(dataExample);
    setImageNull(null);
    setIsModalEditVisible(true);
  };

  return (
    <>
      <div className="tabled">
        <Card>
          <Row gutter={16}>
            <Col span={24}>
              <label> Tìm kiếm</label>
              <Input
                addonAfter={<SearchOutlined />}
                placeholder="Nhập tên chương trình..."
                onChange={getAdsDebounce}
                style={{
                  width: "100%",
                }}
              />
            </Col>
          </Row>
        </Card>

        <br />
        <Space size={10}>
          <Button type="dashed" size="small" onClick={() => showCreateModal()}>
            <EditOutlined /> &nbsp; Thêm chương trình
          </Button>

          {btnDeleted ? (
            <Button
              value="small"
              type="primary"
              icon={<AiFillDelete />}
              danger
              onClick={() => {
                deleteAllAds();
              }}
            >
              &nbsp; Xóa các mục được chọn
            </Button>
          ) : null}
        </Space>
        <br />
        <br />
        <Card
          bordered={true}
          className="criclebox tablespace mt-10 mb-24"
          //   title="Quản lý user hệ thống"
        >
          <div className="table-responsive">
            <Table
              rowSelection={{
                ...rowSelection,
              }}
              rowKey={(record) => record.id.toString()}
              loading={loading}
              onChange={onChange}
              columns={columns}
              dataSource={lstAds}
              bordered
              className="ant-border-space"
              pagination={{
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions: ["10", "50", "100", "200"],
              }}
            />
          </div>
        </Card>

        <Modal
          title={titleModal}
          visible={isModalEditVisible}
          onOk={form.submit}
          onCancel={() => {
            closePopup();
          }}
          style={{ top: 20 }}
        >
          <div>
            <Form
              initialValues={valueForm}
              form={form}
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item hidden={true} label="Id" name="id">
                <Input />
              </Form.Item>

              <Form.Item
                label="Tên chương trình"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập tên!",
                  },
                ]}
              >
                <Input placeholder="Nhập tên ..." />
              </Form.Item>

              <Form.Item label="Mô tả" name="description">
                <TextArea rows={3} placeholder="Nhập mô tả ..." />
              </Form.Item>

              {/* <Form.Item label="Tên button" name="button">
                <Input placeholder="Nhập tên ..." />
              </Form.Item> */}

              <Row gutter>
                <Col span={12}>
                  <Form.Item
                    label="Thứ tự hiển thị"
                    name="order"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập thứ tự hiển thị!",
                      },
                    ]}
                  >
                    <InputNumber min={0} />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Trạng thái"
                    valuePropName="checked"
                    name="status"
                  >
                    <Switch />
                  </Form.Item>
                </Col>

                <Col offset={1}></Col>
              </Row>

              <Form.Item
                label="Liên kết"
                name="link"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập liên kết!",
                  },
                ]}
              >
                <Input placeholder="Nhập liên kết..." />
              </Form.Item>

              <Form.Item label="Ảnh hiển thị">
                <UploadFile />
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AdsProducts;
